import s from './style.module.scss'

type Props = {
  isActive: boolean
}

const ActiveLink = ({isActive}: Props) => {
  if (!isActive) {
    return null
  }
  return <div className={s.active_link} />
}

export default ActiveLink
